import config from "../../config";
import {
  apiVersion,
  AustriaEntity,
  GermanyEntity,
  userGuideUrlDEandAT,
} from "../../shared/constants/common.constant";
import { PreSignedURLResponse } from "../../shared/types/common.type";
import { getAsync } from "../protect-api";

export const getUserGuideDownloadURL = async (
  language?: string
): Promise<PreSignedURLResponse> => {
  try {
    // ToDo: we need to remove this condition once we have the api with language support
    if (language === GermanyEntity || language === AustriaEntity)
      return {
        downloadUrl: userGuideUrlDEandAT,
        fileName: "KYC Protect User Guide.pdf",
        expiresAt: "",
        apiFailed: false,
      };

    const { data } = await getAsync(
      `${config.COMPLIANCE_API_URL}/${apiVersion}/support/userGuide`,
      undefined,
      undefined,
      true
    );
    return {
      downloadUrl: data.downloadUrl,
      fileName: data.fileName,
      expiresAt: data.expiresAt,
      apiFailed: false,
    };
  } catch (error) {
    return {
      downloadUrl: "",
      fileName: "",
      expiresAt: "",
      apiFailed: true,
    };
  }
};
